import { Observable, ReplaySubject, Subject } from "rxjs";
import { map } from "rxjs/operators";

export class Cacheable<T> {
  protected data: T | null = null;
  protected subjectData: Subject<T>;
  protected observableData: Observable<T>;
  public getHandler!: () => Observable<T>;

  constructor() {
    this.subjectData = new ReplaySubject(1);
    this.observableData = this.subjectData.asObservable();
  }

  public getData(): Observable<T> {
    if (!this.getHandler) {
      throw new Error("getHandler is not defined");
    }

    if (!this.data) {
      this.getHandler()
        .pipe(
          // Use pipe to chain operators
          map((r: T) => {
            this.data = r;
            console.log("http call executed is: " + JSON.stringify(this.data));
            return r;
          })
        )
        .subscribe(
          (result: T) => {
            this.subjectData.next(result);
          },
          (err: any) => this.subjectData.error(err)
        );
    }

    //console.log("get observableData:");

    return this.observableData;
  }

  public resetCache(): void {
    this.data = null;
  }

  public refresh(): Observable<T> {
    this.resetCache();
    return this.getData();
  }
}
